import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPracticeListRequest } from "../../../redux/exam/examSlice";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./PracticeDashboard.css";
import images from "../../../utilities/images/images";
import { setTestType } from "../../../redux/exam/examSlice";

const PracticeDashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { practiceList, loading, error } = useSelector(
    (state) => state.examSlice
  );

  useEffect(() => {
    dispatch(fetchPracticeListRequest());
  }, [dispatch]);

  const routeMap = {
    "PYQ NEET": "/pyq",
    "PYQ Mains": "/pyq",
    "PYQ Advance": "/pyq",
    "All India Test Series": "/ots",
    "All India Test series+Brahmastra Test Series": "/ots",
    "All In One Test Series": "/ots",
    "Exam Cracker (Neet)": "/exam_cracker",
    "Exam Cracker (JEE Mains)": "/exam_cracker",
    "Exam Cracker (JEE Advanced)": "/exam_cracker",
    "Unlimited Question Bank": "/question_bank",
    "Conceptual Problem Sheets": "/cps",
    "Adaptive CPS": "/create-adaptive-cps",
    Exams: "/exam",
    "Mock Tests": "/mock_test",
    "NCERT Click": "/ncert",
  };

  const handleNavigate = (item) => {
    const path = routeMap[item?.name];

    if (path) {
      window.location.href = path;
      dispatch(setTestType(item));
    } else {
      console.warn("⚠️ No route mapped for:", item?.name);
    }
  };

  const renderSection = (section) => {
    if (!section) return null;

    return (
      <>
        <h2 className="section-title">{section.title}</h2>
        <div className="section">
          <div className="dashboard-grid">
            {section.data?.map((item, index) => (
              <div
                key={item?.id + index}
                className="dashboard-grid-item"
                onClick={() => handleNavigate(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="icon-container">
                  <img
                    src={item?.icon || item?.pimage}
                    alt={item?.name || item?.sublistName}
                    className="icon"
                  />
                </div>
                <p className="item-name">{item?.name || item?.sublistName}</p>
                {item?.tag && (
                  <span
                    className="item-tag"
                    style={{
                      backgroundColor: item?.tag_color,
                      color: "#fff",
                    }}
                  >
                    {item?.tag}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="practice-dashboard">
      <div className="d-flex justify-center align-center">
        <div>
          <img
            style={{ width: "24px", height: "24px", cursor: "pointer" }}
            src={images.new_backarrow}
            alt="Back"
            onClick={() => history.goBack()}
          />
        </div>
        <div style={{ marginLeft: "35px" }}>Practice</div>
      </div>

      {renderSection(practiceList?.main_practice_dashboard)}
      {renderSection(practiceList?.enhance_your_practice)}
    </div>
  );
};

export default PracticeDashboard;
